import { connect } from 'react-redux';
import ImportSiswaUnit from '../../views/Settings/ImportSiswaUnit.view';
import { getYearsOfEducationsOptions, getPeriodsOptions, getParamOptionsAcademics } from '../../states/thunks/options.thunk';
import { uploadExcelStudentsUnit, listStudentUploadUnit, listStudentTempUpload, postingUpload } from '../../states/thunks/academics.thunk';

function mapStateToProps(state) {
  return {
    result: state.result,
    user: state.user || {},
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleListStudentUploadUnit: (payload, goback) => dispatch(listStudentUploadUnit(payload, goback)),
    handleListStudentTempUpload: (payload, goback) => dispatch(listStudentTempUpload(payload, goback)),
    getYearsOfEducationsOptions: payload => dispatch(getYearsOfEducationsOptions(payload)),
    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
    getParamOptionsAcademics: (payload, type) => dispatch(getParamOptionsAcademics(payload, type)),
    handleUploadExcelStudentsUnit: (payload, goBack) => dispatch(uploadExcelStudentsUnit(payload, goBack)),
    handlePostingUpload: (payload, goBack) => dispatch(postingUpload(payload, goBack)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ImportSiswaUnit);
